import "../../_snowpack/pkg/delayed-scroll-restoration-polyfill.js";
if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}
